<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formupdateSubTag" @submit="submitForm($event, 'updateSubTag')">
            <CInput
                :isValid="checkIfFormValid({
                    formName:'updateSubTag',
                    fieldName:'name'
                })"
                :placeholder="$t('enter_a_name')"
                :value.sync="$v.forms.updateSubTag.name.$model"
                :label="$t('name')"

            />

            <CInput
                :isValid="checkIfFormValid({
                    formName:'updateSubTag',
                    fieldName:'code'
                })"
                :placeholder="$t('enter_a_code')"
                :value.sync="$v.forms.updateSubTag.code.$model"
                :label="$t('code')"

            />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.updateSubTag._loading"
            >
                <span>{{ $t('update_sub_tag') }}</span>
            </ButtonLoading>

        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm" :loading="forms.updateSubTag._loading">
                {{ $t("update_sub_tag") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
/** Components */
import ButtonLoading from '~/components/ButtonLoading.vue';

/** Mixins */
import formMixin from '~/mixins/form';
import modalComponentMixin from '~/mixins/modalComponent';

/** Others */
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators"
export default {
    name: "UpdateSubTagModal",
    mixins: [
        formMixin, 
        validationMixin,
        modalComponentMixin
    ],
    components: {
        ButtonLoading
    },
    data(){
        return {
            forms:{
                updateSubTag:{
                    name: null,
                    code:null,
                    tagUuid:null,
                    _loading: false
                },
            }
        }
    },
    validations:{
        forms:{
            updateSubTag:{
                name:{
                    required
                },
                code:{
                    required
                }
            }
        }
    },

    watch:{
        show(){
            this.showComponent = this.show;
            if(!this.show){
                this.resetForms();
                this.$v.$reset();
            }
        },
        dataComponent(){
            if(this.dataComponent.tagUuid)
                this.forms.updateSubTag.tagUuid = this.dataComponent.tagUuid;
        }
    },

    methods:{
        async submitForm(e, formName){
            e.preventDefault();
            await this.sendForm({ 
                formName , 
                url: '/sub-tags/' + this.dataComponent.subTagUuid,
                method: 'PUT',
                fetch:{
                    baseURL: process.env.VUE_APP_API_CORE,
                }
            });
            this.showComponent = false;
            this.$emit('submit',formName);
        }
    }
};
</script>

<style>
</style>